
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import VerticalTabs from 'components/VerticalTabs'
import {connect} from 'react-redux'
import MappedView from './MappedView'
import UnMappedView from './UnMappedView'

const tabs = [
  {
    key: 'unmapped',
    label: 'Unmapped',
    component: UnMappedView,
    to: `/settings/utm-mapping/unmapped`
  },
  {
    key: 'mapped',
    label: 'Mapped',
    component: MappedView,
    to: `/settings/utm-mapping/mapped`
  }
]

export class SettingsUtmMappingView extends React.Component {
  static propTypes = {
    type: PropTypes.string
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    const {type} = this.props
    const Component = tabs.find(item => item.key === type).component

    return (
      <div className='settings-utm-mapping-view container'>
        <div className='settings-utm-mapping-view_menu'>
          <VerticalTabs items={tabs} activeItemId={type} />
        </div>
        <div className='settings-utm-mapping-view_mappings'>
          <Component key={type} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, {params: {type}}) => ({
  type
})

export default connect(mapStateToProps, {})(SettingsUtmMappingView)



// WEBPACK FOOTER //
// ./client/views/SettingsUtmMappingView/index.js